/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!***************************************!*\
  !*** ./src/js/formula-finder-2026.js ***!
  \***************************************/
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * Formula Finder (RB2026)
 *
 * Handles the filter dropdowns and the mobile scroll carousel for the Formula Finder section.
 *
 * The section renders filter values onto each slide as data-formula-values-<index>, where the
 * index matches the data-formula-filter-index on the corresponding dropdown. Values within a
 * single metafield are joined by '||'. Matching is OR within a filter and AND across filters.
 *
 * The shade selector, add to bag, wishlist and waitlist are handled by quick-view.js, cart.js
 * and the Wishlist King and Restock Rocket apps.
 */
var VALUE_SEPARATOR = '||';
/**
 * Reads the filter values for a slide as a lowercased array.
 * @param {HTMLElement} slide
 * @param {Number} filterIndex
 * @returns {Array<String>}
 */

var getSlideValues = function getSlideValues(slide, filterIndex) {
  var raw = slide.getAttribute("data-formula-values-".concat(filterIndex));
  if (!raw) return [];
  return raw.split(VALUE_SEPARATOR).map(function (value) {
    return value.trim().toLowerCase();
  }).filter(Boolean);
};
/**
 * Initialises a single Formula Finder section.
 * @param {HTMLElement} root
 * @returns {void}
 */


var initFormulaFinder = function initFormulaFinder(root) {
  if (!root || root.dataset.formulaFinderReady === 'true') return;
  root.dataset.formulaFinderReady = 'true';
  var track = root.querySelector('[data-formula-track]');
  var slides = Array.from(root.querySelectorAll('[data-formula-slide]'));
  var filters = Array.from(root.querySelectorAll('[data-formula-filter]'));
  var prevButton = root.querySelector('[data-formula-prev]');
  var nextButton = root.querySelector('[data-formula-next]');
  var emptyMessage = root.querySelector('[data-formula-empty]');
  if (!track || slides.length === 0) return;
  /**
   * Builds the currently selected values, keyed by filter index.
   * @returns {Object}
   */

  var getActiveSelections = function getActiveSelections() {
    var selections = {};
    filters.forEach(function (filter) {
      var filterIndex = filter.dataset.formulaFilterIndex;
      var checked = Array.from(filter.querySelectorAll('[data-formula-filter-input]:checked'));

      if (checked.length > 0) {
        selections[filterIndex] = checked.map(function (input) {
          return input.value.trim().toLowerCase();
        });
      }
    });
    return selections;
  };
  /**
   * Updates a dropdown button to reflect its selection, and shows or hides its clear button.
   * @param {HTMLElement} filter
   * @returns {void}
   */


  var updateFilterLabel = function updateFilterLabel(filter) {
    var toggle = filter.querySelector('[data-formula-filter-toggle]');
    var label = filter.querySelector('[data-formula-filter-label]');
    var clearButton = filter.querySelector('[data-formula-filter-clear]');
    var checked = Array.from(filter.querySelectorAll('[data-formula-filter-input]:checked'));
    var title = toggle.dataset.formulaFilterTitle;

    if (label) {
      if (checked.length === 1) {
        label.textContent = checked[0].value;
      } else if (checked.length > 1) {
        label.textContent = "".concat(title, " (").concat(checked.length, ")");
      } else {
        label.textContent = title;
      }
    } // Matches the selected tab state used elsewhere on the site.


    toggle.classList.toggle('bg-pink-raspberry', checked.length > 0);
    toggle.classList.toggle('text-white', checked.length > 0);
    toggle.classList.toggle('border-pink-raspberry', checked.length > 0);

    if (clearButton) {
      clearButton.classList.toggle('hidden', checked.length === 0);
    }
  };
  /**
   * Shows or hides a control, keeping it out of the tab order while hidden.
   * @param {HTMLElement} button
   * @param {Boolean} hidden
   * @returns {void}
   */


  var setControlHidden = function setControlHidden(button, hidden) {
    button.classList.toggle('opacity-0', hidden);
    button.classList.toggle('pointer-events-none', hidden);
    button.tabIndex = hidden ? -1 : 0;
  };
  /**
   * Shows or hides the mobile controls based on how far the track can still scroll.
   * @returns {void}
   */


  var updateNavButtons = function updateNavButtons() {
    var canScroll = track.scrollWidth - track.clientWidth > 4;
    var atStart = track.scrollLeft <= 4;
    var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    if (prevButton) setControlHidden(prevButton, !canScroll || atStart);
    if (nextButton) setControlHidden(nextButton, !canScroll || atEnd);
  };
  /**
   * Scrolls one card in the given direction.
   *
   * The step is the gap between two adjacent visible slides, so it holds regardless of how
   * many cards are visible at once (a single peeking card on mobile, four flush on desktop).
   * Scroll snap then settles the track on the nearest slide, so the step doesn't need to be
   * exact, and the first and last slides simply clamp to the ends of the scroll range.
   *
   * @param {Number} direction 1 for the next slide, -1 for the previous
   * @returns {void}
   */


  var scrollToNeighbour = function scrollToNeighbour(direction) {
    var _slides$filter = slides.filter(function (slide) {
      return !slide.hidden;
    }),
        _slides$filter2 = _slicedToArray(_slides$filter, 2),
        firstSlide = _slides$filter2[0],
        secondSlide = _slides$filter2[1];

    if (!firstSlide) return;
    var step = secondSlide ? secondSlide.getBoundingClientRect().left - firstSlide.getBoundingClientRect().left : firstSlide.getBoundingClientRect().width;
    track.scrollBy({
      left: direction * step,
      behavior: 'smooth'
    });
  };
  /**
   * Applies the active filters to the slides.
   * @returns {void}
   */


  var applyFilters = function applyFilters() {
    var selections = getActiveSelections();
    var filterIndexes = Object.keys(selections);
    var visibleCount = 0;
    slides.forEach(function (slide) {
      // A slide matches when every active filter is satisfied by at least one of its values.
      var matches = filterIndexes.every(function (filterIndex) {
        var slideValues = getSlideValues(slide, filterIndex);
        return selections[filterIndex].some(function (selected) {
          return slideValues.includes(selected);
        });
      });
      slide.hidden = !matches;
      if (matches) visibleCount += 1;
    });

    if (emptyMessage) {
      emptyMessage.classList.toggle('hidden', visibleCount > 0);
    } // Returns the carousel to the first result.


    track.scrollTo({
      left: 0,
      behavior: 'smooth'
    });
    requestAnimationFrame(updateNavButtons);
  };
  /**
   * Opens or closes a dropdown panel.
   * @param {HTMLElement} filter
   * @param {Boolean} open
   * @returns {void}
   */


  var setFilterOpen = function setFilterOpen(filter, open) {
    var toggle = filter.querySelector('[data-formula-filter-toggle]');
    var panel = filter.querySelector('[data-formula-filter-panel]');
    var chevron = filter.querySelector('[data-formula-filter-chevron]');
    if (!toggle || !panel) return;
    panel.classList.toggle('hidden', !open);
    panel.classList.toggle('flex', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');

    if (chevron) {
      chevron.classList.toggle('rotate-180', open);
    }
  };
  /**
   * Closes every dropdown, optionally leaving one open.
   * @param {HTMLElement} [exception]
   * @returns {void}
   */


  var closeAllFilters = function closeAllFilters(exception) {
    filters.forEach(function (filter) {
      if (filter !== exception) setFilterOpen(filter, false);
    });
  };

  filters.forEach(function (filter) {
    var toggle = filter.querySelector('[data-formula-filter-toggle]');
    var panel = filter.querySelector('[data-formula-filter-panel]');
    var clearButton = filter.querySelector('[data-formula-filter-clear]');
    if (!toggle || !panel) return;
    toggle.addEventListener('click', function () {
      var isOpen = toggle.getAttribute('aria-expanded') === 'true';
      closeAllFilters(filter);
      setFilterOpen(filter, !isOpen);
    });
    panel.addEventListener('change', function (event) {
      if (!event.target.matches('[data-formula-filter-input]')) return;
      updateFilterLabel(filter);
      applyFilters();
    });

    if (clearButton) {
      clearButton.addEventListener('click', function () {
        filter.querySelectorAll('[data-formula-filter-input]:checked').forEach(function (input) {
          input.checked = false;
        });
        updateFilterLabel(filter);
        applyFilters();
        setFilterOpen(filter, false);
      });
    }
  });

  if (filters.length > 0) {
    document.addEventListener('click', function (event) {
      if (!event.target.closest('[data-formula-filter]')) closeAllFilters();
    });
    root.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return; // Read before closing, then focus once closed.

      var openToggle = root.querySelector('[data-formula-filter-toggle][aria-expanded="true"]');
      closeAllFilters();
      if (openToggle) openToggle.focus();
    });
  }

  if (prevButton || nextButton) {
    if (prevButton) prevButton.addEventListener('click', function () {
      return scrollToNeighbour(-1);
    });
    if (nextButton) nextButton.addEventListener('click', function () {
      return scrollToNeighbour(1);
    });
    track.addEventListener('scroll', updateNavButtons, {
      passive: true
    });
    window.addEventListener('resize', updateNavButtons);
    updateNavButtons();
  }
};
/**
 * Initialises every Formula Finder section on the page.
 * @param {ParentNode} [container]
 * @returns {void}
 */


var initFormulaFinders = function initFormulaFinders() {
  var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  container.querySelectorAll('[data-formula-finder]').forEach(initFormulaFinder);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    return initFormulaFinders();
  });
} else {
  initFormulaFinders();
} // Re-initialise when the section is re-rendered in the theme editor.


document.addEventListener('shopify:section:load', function (event) {
  initFormulaFinders(event.target);
});
/******/ })()
;